exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-history-index-tsx": () => import("./../../../src/pages/history/index.tsx" /* webpackChunkName: "component---src-pages-history-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-maintenance-tsx": () => import("./../../../src/templates/maintenance.tsx" /* webpackChunkName: "component---src-templates-maintenance-tsx" */)
}

